import React from 'react';
import { Header } from '../components/ui/header-2';
import { Footer } from '../components/landing/Footer';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const PlaceholderPage = ({ title }: { title: string }) => {
    return (
        <>
            <Header />
            <main style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '120px 24px' }}>
                <div className="container" style={{ maxWidth: '600px' }}>
                    <div style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-subtle)', borderRadius: '24px', padding: '64px 32px' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '24px' }}>🚧</div>
                        <h1 style={{ fontSize: '2.5rem', fontFamily: 'var(--font-display)', marginBottom: '16px' }}>
                            {title}
                        </h1>
                        <p style={{ color: 'var(--text-secondary)', fontSize: '1.25rem', marginBottom: '40px' }}>
                            We are currently building out this section of the premium SaaS experience. Check back soon.
                        </p>
                        <Link to="/" className="btn btn-outline" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                            <ArrowLeft size={16} /> Return Home
                        </Link>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};
